import { useQuery } from '@apollo/client';
import { GET_USERS_PEAK_LISTS, PeakListsSuccessResponse, Variables } from './query';

export const refetchUsersPeakLists = (variables: Variables) => ({query: GET_USERS_PEAK_LISTS, variables});

export const useUsersPeakLists = (variables: Variables) => useQuery<PeakListsSuccessResponse, Variables>(
  GET_USERS_PEAK_LISTS, {variables},
);
